import { render, staticRenderFns } from "./DisplayDetails.vue?vue&type=template&id=481b455e"
import script from "./DisplayDetails.vue?vue&type=script&lang=js"
export * from "./DisplayDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports